import React from "react";
export default function HeaderAd() {
  return <div className="add-container flex md:justify-end"></div>;
}
